import React, { Fragment, useState, useEffect } from "react";
import Addcart from "../addCart/AddCart";
import "../css/cart.css";
import jwtDecode from "jwt-decode";
import { getToken } from "../../../api/token";

export default function CarritoEnProductos(props) {
      const { idProducto, left, top, addProductCart, width, height } = props;
      const [iduser, setIduser] = useState(null)

     useEffect(() => {
        const token = getToken();
        if(token){
          setIduser(jwtDecode(token).data.user.id);
        }
        
      }, [])
    
    if (iduser != null) {
       const AgregaralCarrito = async (idP, idU) => {
         return Addcart(idP, idU);
       };
       return (
         <Fragment>
           <button
             className="image_wrapper"
             style={{ left: left, top: top, width: width, height: height }}
             onClick={() => AgregaralCarrito(iduser, idProducto)}
           >
             
           </button>
         </Fragment>
       );
     } else {
   
    
       return (
         <Fragment>
           <button
             className="image_wrapper"
             style={{ left: left, top: top, width: width, height: height }}
             onClick={() => addProductCart(idProducto)}
           >
            
           </button>
         </Fragment>
       );
     }
}
